import { WithStyles, withStyles } from '@material-ui/styles'
import { bind } from 'bind-decorator'
import { appConfig } from 'config'
import { observer } from 'mobx-react'
import React from 'react'
import { contentStore } from 'stores/contentStore/contentStore'
import { languageStore } from 'stores/languageStore'
import { routerStore } from 'stores/routerStore'
import { introPageStyles } from './introPage.style'
import MillimeterpapierImg from './icons/Millimeterpapier.svg'
import FogBgImg from './icons/FogBg.png'
import { safeHtml } from 'utils/validation'
import { convertRichTextToDesiredStyling } from 'projects/snb-stories/utils/textHelpers'
import NextButton from '../buttons/nextButton'
import RotationCheck from '../RotationCheck'

export type IntroPageProps = WithStyles<typeof introPageStyles>

@observer
class IntroPageCls extends React.Component<IntroPageProps> {
  languageIndexMap: { [lang: string]: number } = {}

  async componentDidMount() {
    const nOfIntroPageData = Object.keys(contentStore.introPage).length
    if (!nOfIntroPageData) {
      await contentStore.fetchIntro()
      if (contentStore.chapters.length === 0) {
        contentStore.fetchData().catch((err) => console.error(err))
      }
    }
  }

  clickHandler() {
    routerStore.push(`/${appConfig.contentUnitUrl}/`)
  }

  @bind
  selectLanguage(lang: string) {
    return () => {
      languageStore.selectLanguage(lang)
    }
  }

  render() {
    const { classes } = this.props
    if (!contentStore.introPage) {
      return null
    }
    let title = ''
    let secondaryTitle = ''
    let backgroundImage = ''
    let startButtonText = ''
    if (contentStore.introPage[languageStore.language]) {
      secondaryTitle =
        contentStore.introPage[languageStore.language].secondaryTitle
      backgroundImage =
        contentStore.introPage[languageStore.language].backgroundImage
      startButtonText =
        contentStore.introPage[languageStore.language].startButtonText

      title = convertRichTextToDesiredStyling(
        contentStore.uiElements?.SEOSubtitle ?? '',
        [
          { '<strong>': '<strong style="font-family: Chivo">' },
          { '<p>': '<p style="font-weight:300">' },
        ]
      )
    }

    return (
      <div className={classes.container}>
        <RotationCheck />
        <img
          alt="bg-factory"
          className={classes.containerImageBg}
          src={backgroundImage}
        />
        <img
          alt="mesh"
          className={classes.containerBg}
          src={MillimeterpapierImg}
        />
        <div className={classes.content}>
          <img alt="fog" src={FogBgImg} className={classes.fogBg} />
          <div className={classes['secondary-title-wrapper']}>
            <h2 data-at="secondaryTitle" className={classes['secondary-title']}>
              {secondaryTitle}
            </h2>
          </div>
          {/* eslint-disable-next-line jsx-a11y/heading-has-content */}
          <h1
            className={classes.title}
            {...safeHtml(title)}
            data-at="title"
          ></h1>
          <div className={classes['intro-next-button']}>
            <NextButton text={startButtonText} onClick={this.clickHandler} />
          </div>
        </div>
      </div>
    )
  }
}

export default withStyles(introPageStyles, { name: 'IntroPage' })(IntroPageCls)
